import { get, post,put } from "../Config";

// GET
export function ReceiptHistoryList({ params }) {
  return get({ url: `/api/koala/v1/upload-receipt-history`, params });
}

export function ReceiptHistoryConcert({ params }) {
  return get({ url: `/api/koala/v1/upload-receipt-history/event`, params });
}